import { IUser } from "../../types/api/user";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface AuthState {
  userInfo: IUser | null;
  setUserInfo: (data: IUser) => void;
  getUserInfo: () => IUser | null;
}

export const useAuthStore = create<AuthState>()(
  devtools((set, get) => ({
    userInfo: null,

    setUserInfo: (data: IUser) => {
      set({ userInfo: data });
    },

    getUserInfo: () => {
      return get().userInfo;
    },
  }))
);
